/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hours: NonNullable<unknown> }} Booking_Portal_HoursInputs */

const en_booking_portal_hours = /** @type {(inputs: Booking_Portal_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours} h`)
};

const pl_booking_portal_hours = /** @type {(inputs: Booking_Portal_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours} godz.`)
};

/**
* | output |
* | --- |
* | "{hours} h" |
*
* @param {Booking_Portal_HoursInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_hours = /** @type {((inputs: Booking_Portal_HoursInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_HoursInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_hours(inputs)
	return en_booking_portal_hours(inputs)
});